import React from 'react';

const Visa = () => {
    return (
      <div>

        <div class="p-5 sm:px-10 md:px-20" id="companies">
          <div class="max-w-screen-xl mx-auto">
            <img
              class="mx-auto"
              src="https://storage.googleapis.com/devitary-image-host.appspot.com/15846471026680582071-Strip-Payment-Logos.png"
              alt=""
            />
          </div>
        </div>
      </div>
    );
};

export default Visa;